export default () => {
  const authStore = useAuthStore()
  const isLoading = ref(false)
  const error = ref('')

  const detectCountry = async () => {
    isLoading.value = true
    error.value = ''

    try {
      if (authStore.countryCode) {
        return authStore.countryCode
      }
      const ip = await $fetch('https://get.geojs.io/v1/ip')
      const response = await $fetch(`https://get.geojs.io/v1/ip/country/${ip}.json`)
      authStore.setCountryCode(response.country)
      return response.country
    } catch (err) {
      error.value = 'Failed to detect country'
      console.error('Error detecting country:', err)
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    error,
    detectCountry,
  }
}
